import React, { FC } from 'react';

// components
import Deeplink from '../../../../components/formulas/settings/Deeplink';
import styled from 'styled-components';

// theme
import aampeTheme from '../../../../constants/aampeTheme';

// hooks
import useDatasetByIdQuery from '../../../../hooks/datasets/useDatasetByIdQuery';

// models
import {
    FormulaDetailModel,
    FormulaTypesData,
} from '../../../../models/formula.model';

interface DeeplinkEditorProps {
    formula: FormulaDetailModel;
    isDisabled?: boolean;
    className?: string;
}

const DeeplinkEditor: FC<React.PropsWithChildren<DeeplinkEditorProps>> = ({
    formula,
    className,
}) => {
    const { data: dataset } = useDatasetByIdQuery(formula?.dataset_id);
    if (
        formula.message_type &&
        FormulaTypesData[formula.message_type].supportDeeplink
    ) {
        return (
            <Container className={className}>
                <Heading>Deeplink</Heading>
                <Deeplink formula={formula} dataset={dataset!} />
            </Container>
        );
    }

    return null;
};

const Container = styled.div(() => ({
    marginTop: aampeTheme.spacing(1),
    padding: aampeTheme.spacing(0.5),
}));

const Heading = styled.p(() => ({
    fontWeight: aampeTheme.weights.medium,
    marginBottom: aampeTheme.spacing(0.5),
    fontSize: aampeTheme.size.font.textMedium,
}));

export default DeeplinkEditor;
